import {
  LOWERCASE_DIGITS_UNDERSCORE,
  PHONETICS,
  SPACES_TO_UNDERSCORE,
  validateString,
} from '@/helpers/validateString';
import { RouteLocationNormalizedLoaded } from 'vue-router';
import jumpToAnchor from '@/helpers/article/jumpToAnchor';

export default function setArticleAnchors(route: RouteLocationNormalizedLoaded) {
  const h2s = document.querySelectorAll('.article__content h2');
  const h2sArray = Array.from(h2s);
  h2sArray.forEach((el) => {
    const el2 = el;
    const anchorText = validateString((el2 as HTMLElement).innerText, LOWERCASE_DIGITS_UNDERSCORE, PHONETICS.concat(SPACES_TO_UNDERSCORE)).trim();
    const anchor = document.createElement('a');
    anchor.setAttribute('id', anchorText);
    anchor.setAttribute('href', `${route.fullPath.replace(route.hash, '')}#${anchorText}`);
    anchor.innerHTML = (el2 as HTMLElement).innerHTML;
    anchor.onclick = (e) => {
      e.preventDefault();
      window.history.pushState(
        {},
        null as any,
        anchor.href,
      );
      jumpToAnchor();
    };
    el2.innerHTML = '';
    el2.appendChild(anchor);
  });
}
